import React from "react";
import '.././PopupCommonStyle.css'
import styles from "./Style.module.css";
import { BtnPrimary } from "../../Buttons/BtnPrimary";

export const ReloadBookingPopup = ({
  active,
  handleClick,
  status,
  onReload,
}) => {
  return (
    <div
      className={`popup 
        ${styles.ReloadBookingPopup} 
        ${active ? "show" : ""}
        `}
    >
      <div className={`${styles.popHeader} popup-header`}>
            <h2 className="title">
              Your appointment has been <strong>{status}</strong>.
            </h2>
            <p className="titleSub">
             This appointment has already been {status.toLowerCase()}, so you can no longer reschedule/cancel it.
            </p>
      </div>
      <div className={`${styles.footer} popup-footer`}>
            <BtnPrimary
              label="Ok, Got It"
              customClass="w-100 no-icon"
              handleClick={onReload || handleClick}
            />
        </div>
    </div>
  );
};
